import { PortalkonfigurationDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode, GlobalEnumsAceJaNein, GlobalEnumsAcePrioritaet, GutachtenListDisplayModel, LocalizedTextDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { DataStateChangeEvent, GridDataResult, MultipleSortSettings } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { process, State, SortDescriptor } from '@progress/kendo-data-query';
import { GlobalEnumsAceBewertung } from '../../../../../api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-bewertung';
import { LoadingAnimationService } from '../../../../services/loading-animation.service';
import { GutachtenDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/gutachten-display-model';
import { formatNumber } from '@progress/kendo-intl';
import { DialogService } from '@progress/kendo-angular-dialog';
import { BefangenheitsDialogResult, BefangenheitsdialogComponent } from '../befangenheitsdialog/befangenheitsdialog.component';
import { Constants } from '@/constants';
import { ConfirmationDialogAction } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { GutachtenService } from '@/api/service-index';
import { FormularService } from '@/core/services/formular.service';

@Component({
    selector: 'review-overview',
    templateUrl: './review-overview.component.html',
    styleUrls: ['./review-overview.component.scss']
})
export class ReviewOverviewComponent implements OnInit, AfterViewInit {
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    protected reviewList: GutachtenListDisplayModel[];
    public gridData: GridDataResult;
    public isBefangenheitsdialogOpen = false;
    public sortSettings: MultipleSortSettings = {
        mode: "multiple",
        allowUnsort: true,
        showIndexes: true,
        multiSortKey: "shift"
    };

    public sort: SortDescriptor[] = [
        {
            field: 'anfrageNummer',
            dir: 'asc'
        },
    ];

    public state: State = {
        sort: this.sort
    };

    public languageChangeSubscription: Subscription;

    constructor(protected router: Router, protected route: ActivatedRoute,
        protected languageservice: I18nService, protected loadingAnimationService: LoadingAnimationService,
        protected dialogService: DialogService, protected gutachtenService: GutachtenService,
        protected formularService: FormularService) {

    }

    ngAfterViewInit(): void {
        this.checkVisibilityStateOfGridCorner();
    }

    protected checkVisibilityStateOfGridCorner() {
        const gridContentRefs = document.getElementsByClassName("k-grid-content");
        const gridHeaderRefs = document.getElementsByClassName("k-grid-header");

        if (gridContentRefs.length > 0 && gridHeaderRefs.length > 0) {
            const gridContentRef: HTMLElement = gridContentRefs[0] as HTMLElement;
            const gridHeaderRef: HTMLElement = gridHeaderRefs[0] as HTMLElement;
    
            if (gridContentRef && gridHeaderRef) {
                if (gridContentRef.scrollHeight == gridContentRef.clientHeight) {
                    //hide the corner
                    gridHeaderRef.style.padding = "0px";
                }
                else {
                    //show the corner
                    gridHeaderRef.style.padding = "padding: 0px 15px 0px 0px;";
                }
            }
        }
    }

    ngOnInit(): void {
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
        this.reviewList = this.route.snapshot.data.gutachtenListe;

        this.languageChangeSubscription = this.languageservice.languageChanged$.subscribe(() => {
            this.reloadTable();
        })

        this.reloadTable();
    }

    public get showList(): boolean {
        return this.reviewList?.length > 0;
    }

    public get title(): string {
        let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.willkommenstexteGutachter);
        return title?.text ?? "";
    }

    public get subtitle(): string {
        let subtitle: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.infotexteGutachter);
        return subtitle?.text ?? "";
    }

    public onButtonClicked(gutachten: GutachtenListDisplayModel) {
        if (this.portalkonfiguration.befangenheitsdialog == GlobalEnumsAceJaNein.Ja && gutachten.statuscode == AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.FreigegebenzurBegutachtung) {
            if (this.isBefangenheitsdialogOpen) {
                return;
            }
            this.isBefangenheitsdialogOpen = true;
            let dialogRef = this.dialogService.open({
                content: BefangenheitsdialogComponent,
                maxWidth: Constants.DIALOG.MAX_WIDTH,
                maxHeight: Constants.DIALOG.MAX_HEIGHT,
                title: this.languageservice.instant("review.befangenheitsdialog.header.title")
            });
            let dialogComponent: BefangenheitsdialogComponent = dialogRef.content.instance;
            dialogComponent.gutachten = gutachten;
            dialogRef.result.subscribe(result => {
                this.onBefangenheitsdialogClose(<BefangenheitsDialogResult>result, gutachten);
                this.isBefangenheitsdialogOpen = false;
            });
        }
        else {
            this.openGutachtenInDetail(gutachten);
        }
    }

    protected onBefangenheitsdialogClose(result: BefangenheitsDialogResult, gutachten: GutachtenListDisplayModel){
        if (result.action == ConfirmationDialogAction.Confirm) {
            let subscription = this.gutachtenService.apiGutachtenUpdateGutachtenBefangenheitPatch({body: result.model}).subscribe(() => {
                if (result.model.befangenheit) {
                    this.reviewList.splice(this.reviewList.findIndex(x => x.gutachtenId == gutachten.gutachtenId), 1);
                    this.reloadTable();
                }
                else {
                    this.openGutachtenInDetail(gutachten);
                }
            })
            this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
        }
    }

    protected openGutachtenInDetail(gutachten: GutachtenListDisplayModel) {
        if (!gutachten.gutachtenPhase || !gutachten.gutachtenPhase.abschnitte)
            throw new Error("Anfrage has no phase or abschnitte.");

        let link = this.formularService.getRouteObjectThrough(gutachten.gutachtenPhase.abschnitte[0]).link.split("/");

        let sectionType = link[0];
        let sectionId = link[1];

        this.router.navigate(['../', 'review', 'detail', gutachten.scope, gutachten.gutachtenId, sectionType, sectionId],
            { relativeTo: this.route });
    }

    public reloadTable() {
        this.gridData = process(this.reviewList, this.state);
        this.checkVisibilityStateOfGridCorner();
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.reloadTable();
    }

    public formatTitle(title: string): string {
        return title ? title : this.languageservice.instant('newAnfrageTitle');
    }

    public formatDate(date: string): string | undefined | null {
        if (date != null)
            return new Date(date).toLocaleDateString(this.languageservice.language);
        return null;
    }

    public formatStatusGrund(reviewitem: GutachtenDisplayModel) {
        if (reviewitem.ausschreibung?.fristFuerBegutachtung != null && Date.parse(reviewitem.ausschreibung?.fristFuerBegutachtung) < Date.now()) {
            return this.languageservice.instant("Enum.review.fristFuerBegutachtungEnded");
        }
        return this.languageservice.instant("Enum.review." + AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.getAsDataset().find(x => x.Value == reviewitem.statuscode)?.Name ?? "");
    }

    public formatBewertung(bewertung: any) {
        return GlobalEnumsAceBewertung.getAsDataset().find(x => x.Value == bewertung)?.Description;
    }

    public formatCurrency(value: number) {
        return formatNumber(value, {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "symbol"
        }, this.languageservice.language)
    }

    public formatPriority(value: GlobalEnumsAcePrioritaet | undefined) {
        const foundEnumName = GlobalEnumsAcePrioritaet.getAsDataset().find(x => x.Value == value)?.Name;

        return foundEnumName ? this.languageservice.instant("Enum.GlobalEnumsAcePrioritaet." + foundEnumName) : "";
    }
}